import lazyLoading from './lazyLoading'
import CommonLayout from '../components/Layouts/Common'
import LogGuard from './guards/log-guard'

export default [
  {
    path: '/',
    component: CommonLayout,
    beforeEnter: LogGuard,
    children: [
      {
        name: 'file.download',
        path: 'file/download',
        component: lazyLoading('Customers/File/Download'),
      },
      {
        path: '*',
        redirect: '/'
      },
    ],
  }
]
